import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { ReportComponent } from './report.component';
import { ReportService } from './report.service';

@NgModule({
  declarations: [
    ReportComponent
  ],
  imports: [
    CommonModule,
    HttpModule
  ],
  providers: [ReportService],
  bootstrap: [ReportComponent],
})

export class ReportModule { }



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/reports/report.module.ts